module.exports = __webpack_public_path__ + "static/media/SZ.2bf1c6ee.png";